import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import debounce from 'lodash.debounce';
import { Unchecked, Checked, Indeterminate } from './shapes/checkbox';
import { alloy, teal, white } from './colors';

function generateUniqueId(label) {
  var uniqueId = "".concat(label, "-").concat(Math.floor(Math.random() * 0xffff));
  return uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
}

var Checkbox = function Checkbox(props) {
  var debouncedChange = debounce(function (e) {
    props.onChange && props.onChange(e, props.payload);
  }, 200, {
    leading: true,
    trailing: false
  });

  var handleChange = function handleChange(e) {
    e.persist();
    debouncedChange(e);
  };

  var checked = props.checked,
      indeterminate = props.indeterminate,
      label = props.label,
      disabled = props.disabled,
      className = props.className,
      style = props.style,
      whiteBackground = props.whiteBackground,
      id = props.id;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1]; // build a unique ID for this field in case one was not provided
  // logic from https://github.com/callemall/material-ui/blob/master/src/Checkbox/Checkbox.js


  var _useState3 = useState(id),
      _useState4 = _slicedToArray(_useState3, 2),
      inputId = _useState4[0],
      setInputId = _useState4[1];

  useEffect(function () {
    if (!inputId) {
      setInputId(generateUniqueId(label));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var backgroundColor = whiteBackground ? white : undefined;
  var image;

  if (checked) {
    image = disabled ? React.createElement(Checked, {
      color: alloy,
      backgroundColor: backgroundColor
    }) : React.createElement(Checked, {
      backgroundColor: backgroundColor
    });
  } else if (indeterminate) {
    image = disabled ? React.createElement(Indeterminate, {
      color: alloy,
      backgroundColor: backgroundColor
    }) : React.createElement(Indeterminate, {
      backgroundColor: backgroundColor
    });
  } else {
    image = disabled ? React.createElement(Unchecked, {
      color: alloy,
      backgroundColor: backgroundColor
    }) : hover ? React.createElement(Unchecked, {
      color: teal.base,
      backgroundColor: backgroundColor
    }) : React.createElement(Unchecked, {
      backgroundColor: backgroundColor
    });
  }

  var disabledStyle = disabled ? {
    cursor: 'not-allowed',
    pointerEvents: 'none'
  } : {};
  return React.createElement("div", {
    className: "checkbox ".concat(className),
    style: _objectSpread({}, style, {}, disabledStyle)
  }, React.createElement("label", {
    className: "control-label",
    htmlFor: inputId,
    onClick: disabled ? undefined : handleChange,
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseOut: function onMouseOut() {
      return setHover(false);
    },
    style: _objectSpread({
      paddingLeft: 0
    }, disabledStyle)
  }, React.createElement("span", {
    style: {
      position: 'relative',
      top: '3px',
      paddingRight: '10px'
    }
  }, image), React.createElement("input", {
    type: "checkbox",
    disabled: disabled,
    checked: checked,
    onBlur: function onBlur(e) {
      return props.onBlur && props.onBlur(e);
    },
    onFocus: function onFocus(e) {
      return props.onFocus && props.onFocus(e);
    },
    onChange: handleChange,
    style: {
      visibility: 'hidden'
    }
  }), label));
};

Checkbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  whiteBackground: PropTypes.bool,
  onChange: PropTypes.func,
  payload: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  style: StylePropType
};
Checkbox.defaultProps = {
  disabled: false,
  className: '',
  whiteBackground: false
};
export default Checkbox;